import { Clickstream } from '@gojek/clickstream-web';
import { CLICKSTREAM_DEBUG, CLICKSTREAM_TOKEN, CLICKSTREAM_URL } from '@pukka/common/constants';

function initClickStream(token: string, url: string) {
  return new Clickstream({
    event: {
      classification: {
        // add eventName in this array to send it as QoS0 events. For more: https://go-jek.atlassian.net/wiki/spaces/EP/pages/2515574996/Clickstream+Web+Integration+Manual#Send-QoS0-events
        instant: [],
      },
      group: 'web-mokapos',
    },
    network: {
      url: new URL(url),
      headers: new Headers({
        Authorization: `Basic ${token}`,
      }),
      maxRetries: 5,
      timeBetweenTwoRetries: 3000,
      timeToResumeRetries: 30000,
    },
    debug: CLICKSTREAM_DEBUG === 'true',
  });
}

function setupClickstream() {
  const token = CLICKSTREAM_TOKEN;
  const url = CLICKSTREAM_URL;

  /* istanbul ignore next */
  if (!token || !url) {
    return;
  }

  if (window.shouldStartClickStream) {
    window.clickstream = initClickStream(token, url);
  } else {
    window.initClickStream = function init() {
      window.clickstream = initClickStream(token, url);
    };
  }
}

export { setupClickstream };
